import { lp } from "./logPrefix";
import { guid } from "./util";
import {
  accumulateReport,
  infoFunction,
  IWsSentryReportArgs,
} from "./wsSentry";
import { showSentryDialog } from "./wsSentryDialog";

export function wsSentryReport(args: IWsSentryReportArgs): string {
  const eventId = args.eventId || guid();

  const { alreadyReported, additionalErrorMessageInfo } = args;

  if (args.error) {
    console.error(lp(), args.error);
  }

  let info = {};
  if (infoFunction) {
    info = infoFunction();
  } else {
    console.warn("WsSentry infoFunction is not set");
  }

  const d = {
    ...args,
    ...info,
    alreadyReportedToSentry: true,
    eventId,
    additionalErrorMessageInfo,
  };

  // accumulate events close in time and send them to backend
  if (!alreadyReported) {
    accumulateReport(d);
  }

  if (args.showDialog) {
    showSentryDialog(d);
  }

  return eventId;
}
